// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';

import { InputTextField } from 'gandi.react-form';
import Row from './Row';

type Props = {| category: string, topic?: string |};

function DomainNameField({
  category,
  topic,
}: Props): React.Element<typeof Row> {
  const { __ } = useTranslator();
  return (
    <Row fullRow>
      <InputTextField
        inputMode="url"
        name="resource_name"
        label={
          category === 'hosting' && topic === 'spam'
            ? __('Domain name in question or IP address')
            : __('Domain name in question')
        }
        required
      />
    </Row>
  );
}

export default DomainNameField;
